import { SCHEMA_BOOL_COMP_PROP, SCHEMA_STRING_COMP_PROP } from '../../constants';
import {
	ComponentPropertyDefinition,
	ComponentPropertyEditor,
	ComponentPropertyGroup,
	ComponentStylePropertyDefinition,
} from '../../types/common';
import { COMMON_COMPONENT_PROPERTIES, COMPONENT_STYLE_GROUP_PROPERTIES } from '../util/properties';

const propertiesDefinition: Array<ComponentPropertyDefinition> = [
	{
		name: 'markdownText',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'Markdown Text',
		description: 'Markdown Text',
		defaultValue: '',
		group: ComponentPropertyGroup.BASIC,
		editor: ComponentPropertyEditor.TEXT_EDITOR,
		translatable: true,
	},
	COMMON_COMPONENT_PROPERTIES.colorScheme,
	{
		name: 'showTill',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'Show Headings Till',
		description: 'Show Headings Till',
		editor: ComponentPropertyEditor.ENUM,
		defaultValue: 'H2',
		group: ComponentPropertyGroup.BASIC,
		enumValues: [
			{
				name: 'H1',
				displayName: 'H1',
				description: 'Heading1',
			},
			{
				name: 'H2',
				displayName: 'H2',
				description: 'Heading2',
			},
			{
				name: 'H3',
				displayName: 'H3',
				description: 'Heading3',
			},
			{
				name: 'H4',
				displayName: 'H4',
				description: 'Heading4',
			},
			{
				name: 'H5',
				displayName: 'H5',
				description: 'Heading5',
			},
			{
				name: 'H6',
				displayName: 'H6',
				description: 'Heading6',
			},
		],
	},
	{
		name: 'makeCollapsible',
		schema: SCHEMA_BOOL_COMP_PROP,
		displayName: 'Make Collapsible',
		description: 'Make Collapsible',
		defaultValue: true,
		group: ComponentPropertyGroup.BASIC,
	},
	{
		name: 'makeCollapsibleFrom',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'Make Collapsible From',
		description: 'Make Collapsible From',
		editor: ComponentPropertyEditor.ENUM,
		defaultValue: 'H6',
		group: ComponentPropertyGroup.BASIC,
		enumValues: [
			{
				name: 'H1',
				displayName: 'H1',
				description: 'Heading1',
			},
			{
				name: 'H2',
				displayName: 'H2',
				description: 'Heading2',
			},
			{
				name: 'H3',
				displayName: 'H3',
				description: 'Heading3',
			},
			{
				name: 'H4',
				displayName: 'H4',
				description: 'Heading4',
			},
			{
				name: 'H5',
				displayName: 'H5',
				description: 'Heading5',
			},
			{
				name: 'H6',
				displayName: 'H6',
				description: 'Heading6',
			},
		],
	},
	{
		name: 'titleText',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'Title Text',
		description: 'Text to be shown to for the title.',
		translatable: true,
		group: ComponentPropertyGroup.BASIC,
	},
	{
		name: 'topLabelText',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'Top Label Text',
		description: 'Text to be shown to for the gototop.',
		translatable: true,
		group: ComponentPropertyGroup.ADVANCED,
	},
	{
		name: 'topTextIcon',
		schema: SCHEMA_STRING_COMP_PROP,
		group: ComponentPropertyGroup.ADVANCED,
		displayName: 'Top Icon',
		description: 'Top Icon',
		editor: ComponentPropertyEditor.ICON,
	},
	{
		name: 'topTextImage',
		schema: SCHEMA_STRING_COMP_PROP,
		group: ComponentPropertyGroup.ADVANCED,
		displayName: 'Top Image',
		description: 'Top Image',
		editor: ComponentPropertyEditor.IMAGE,
	},
	{
		name: 'topIconImagePosition',
		schema: SCHEMA_STRING_COMP_PROP,
		group: ComponentPropertyGroup.ADVANCED,
		displayName: 'Top Icon/Image Position',
		description: 'Top Icon/Image Position',
		editor: ComponentPropertyEditor.ENUM,
		defaultValue: '_left',
		enumValues: [
			{
				name: '_left',
				displayName: 'Left',
				description: 'Left',
			},
			{
				name: '_right',
				displayName: 'Right',
				description: 'Right',
			},
		],
	},
	{
		name: 'bottomLabelText',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'Bottom Label Text',
		description: 'Text to be shown to for the gotobottom.',
		translatable: true,
		group: ComponentPropertyGroup.ADVANCED,
	},
	{
		name: 'bottomTextIcon',
		schema: SCHEMA_STRING_COMP_PROP,
		group: ComponentPropertyGroup.ADVANCED,
		displayName: 'Bottom Icon',
		description: 'Bottom Icon',
		editor: ComponentPropertyEditor.ICON,
	},
	{
		name: 'bottomTextImage',
		schema: SCHEMA_STRING_COMP_PROP,
		group: ComponentPropertyGroup.ADVANCED,
		displayName: 'Bottom Image',
		description: 'Bottom Image',
		editor: ComponentPropertyEditor.IMAGE,
	},

	{
		name: 'bottomIconImagePosition',
		schema: SCHEMA_STRING_COMP_PROP,
		group: ComponentPropertyGroup.ADVANCED,
		displayName: 'Bottom Icon/Image Position',
		description: 'Bottom Icon/Image Position',
		editor: ComponentPropertyEditor.ENUM,
		defaultValue: '_left',
		enumValues: [
			{
				name: '_left',
				displayName: 'Left',
				description: 'Left',
			},
			{
				name: '_right',
				displayName: 'Right',
				description: 'Right',
			},
		],
	},

	{
		name: 'bulletType',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'Bullet Type',
		description: 'Bullet Type',
		defaultValue: 'NONE',
		group: ComponentPropertyGroup.ADVANCED,
		enumValues: [
			{
				name: 'NONE',
				displayName: 'None',
				description: 'None',
			},
			{
				name: 'NUMBER',
				displayName: 'Numeric',
				description: 'Numeric',
			},
			{
				name: 'ALPHA',
				displayName: 'Alphabetic',
				description: 'Alphabetic',
			},
			{
				name: 'ROMAN',
				displayName: 'Roman',
				description: 'Roman',
			},
			{
				name: 'ALPHA_UPPERCASE',
				displayName: 'Capital Alphabetic',
				description: 'Capital Alphabetic',
			},
			{
				name: 'ROMAN_UPPERCASE',
				displayName: 'Capital Roman',
				description: 'Capital Roman',
			},
		],
	},

	{
		name: 'bulletIcon',
		schema: SCHEMA_STRING_COMP_PROP,
		group: ComponentPropertyGroup.ADVANCED,
		displayName: 'Bullet Icon',
		description: 'Bullet Icon',
		editor: ComponentPropertyEditor.ICON,
	},

	{
		name: 'bulletImage',
		schema: SCHEMA_STRING_COMP_PROP,
		group: ComponentPropertyGroup.ADVANCED,
		displayName: 'Bullet Image',
		description: 'Bullet Image',
		editor: ComponentPropertyEditor.IMAGE,
	},
];

const stylePropertiesDefinition: ComponentStylePropertyDefinition = {
	'': [
		COMPONENT_STYLE_GROUP_PROPERTIES.layout.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.position.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.size.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.effects.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.background.type,
	],
	titleText: [
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
	],
	H1: [
		COMPONENT_STYLE_GROUP_PROPERTIES.layout.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.position.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.size.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.effects.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.background.type,
	],
	H2: [
		COMPONENT_STYLE_GROUP_PROPERTIES.layout.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.position.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.size.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.effects.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.background.type,
	],
	H3: [
		COMPONENT_STYLE_GROUP_PROPERTIES.layout.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.position.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.size.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.effects.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.background.type,
	],
	H4: [
		COMPONENT_STYLE_GROUP_PROPERTIES.layout.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.position.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.size.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.effects.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.background.type,
	],
	H5: [
		COMPONENT_STYLE_GROUP_PROPERTIES.layout.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.position.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.size.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.effects.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.background.type,
	],
	H6: [
		COMPONENT_STYLE_GROUP_PROPERTIES.layout.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.position.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.size.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.effects.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.background.type,
	],
	collapsibleIcon: [
		COMPONENT_STYLE_GROUP_PROPERTIES.layout.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.position.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.size.type,
	],
	topLabel: [
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
	],
	bottomLabel: [
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
	],
	bulletIconImage: [
		COMPONENT_STYLE_GROUP_PROPERTIES.layout.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.position.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.size.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.effects.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.background.type,
	],
	topIconImage: [
		COMPONENT_STYLE_GROUP_PROPERTIES.layout.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.position.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.size.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.effects.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.background.type,
	],
	bottomIconImage: [
		COMPONENT_STYLE_GROUP_PROPERTIES.layout.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.position.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.size.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.effects.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.background.type,
	],
};

export { propertiesDefinition, stylePropertiesDefinition };
